module.exports = __webpack_public_path__ + "img/phont.c272cd96.png";